export class DataModelLinkTOTP {
    public issuer: string = "";
    public isMobile: boolean = false;
    public isEmail: boolean = true;
}